import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  TextField,
  Checkbox,
  DialogTitle,
  Alert,
  Icon,
  Typography,
  lighten,
} from "@mui/material";
import { MobileDateTimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import esLocale from "date-fns/locale/es";
import { format as DateFormat } from "date-fns";

const DialogoControles = (props) => {
  const { onSave, onClose, boton } = props;
  const [resp, setResp] = React.useState({});
  const [bg, setBg] = React.useState("inherit");
  React.useEffect(() => {
    setBg(lighten(boton.FONDO, 0.8));
  }, [boton]);
  React.useEffect(() => {
    if (boton && boton.CONTROLES && boton.CONTROLES.length === 0) {
      Grabar();
      // } else {
      //   boton !== null &&
      //     boton.CONTROLES.map((c, index) => {
      //       if (c.TIPO === 3) resp[index] = new Date();
      //     });
    }
  }, [boton]);

  const Grabar = () => {
    const c =
      boton &&
      boton.CONTROLES.map((c1, index) => ({
        ID: c1.ID,
        VALOR:
          c1.TIPO === 3
            ? DateFormat(resp[index], "dd/MM/yyyy HH:mm")
            : resp[index] && resp[index].toString(),
      }));
    onSave({ NTF: boton.NTF, RESPUESTA: boton.VALOR, CONTROLES: c });
    onClose();
  };
  return (
    <Dialog open={Boolean(boton)} fullWidth>
      <DialogTitle
        sx={{
          backgroundColor: (boton && boton.FONDO) || "inherit",
          p: 0.5,
          pl: 1,
          pr: 1,
          color: (boton && boton.COLOR) || "inherit",
        }}
        fontSize="medium"
      >
        <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
          {boton && boton.ICONO && <Icon>{boton.ICONO}</Icon>}
          <Typography variant="h6">{boton.DESCRIPCION}</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent
        sx={{
          backgroundColor: bg,
        }}
      >
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={esLocale}
        >
          <Stack spacing={2} direction="column" sx={{ pt: 2 }}>
            <Alert
              severity="warning"
              sx={{
                "& .MuiAlert-message": {
                  fontSize: "0.72rem",
                },
              }}
            >
              Todos los campos con * son requeridos.
            </Alert>
            {boton &&
              boton.CONTROLES &&
              boton.CONTROLES.map((c, index) =>
                c.TIPO < 3 ? (
                  <TextField
                    fullWidth
                    autoFocus={index === 0}
                    required={c.REQUERIDO}
                    value={resp[index] || ""}
                    margin="dense"
                    onChange={(e) => {
                      const r = { ...resp };
                      r[index] = e.target.value !== "" ? e.target.value : null;
                      setResp(r);
                    }}
                    type={c.TIPO === 2 ? "number" : "text"}
                    slotProps={{
                      htmlInput: {
                        maxLength:
                          (c.CARACTERES === 0 && "inherits") || c.CARACTERES,
                      },
                    }}
                    label={c.DESCRIPCION}
                    multiline={c.LINEAS > 1}
                    rows={c.LINEAS > 1 ? c.LINEAS : 1}
                  />
                ) : c.TIPO === 3 ? (
                  <MobileDateTimePicker
                    fullWidth
                    autoFocus={index === 0}
                    formatDensity="spacious"
                    localeText={{ toolbarTitle: "Seleccione fecha y hora" }}
                    slotProps={{
                      textField: {
                        required: c.REQUERIDO,
                      },
                      actionBar: {
                        actions: ["accept"],
                      },
                    }}
                    value={resp[index]}
                    margin="dense"
                    onChange={(newValue) => {
                      const r = { ...resp };
                      r[index] = newValue;
                      setResp(r);
                    }}
                    label={c.DESCRIPCION}
                  />
                ) : c.TIPO === 4 ? (
                  <Checkbox
                    checked={resp[index]}
                    autoFocus={index === 0}
                    onChange={(e) => {
                      const r = { ...resp };
                      r[index] = e.target.checked;
                      setResp(r);
                    }}
                  />
                ) : null,
              )}
          </Stack>
        </LocalizationProvider>
      </DialogContent>
      <DialogActions
        sx={{
          backgroundColor: bg,
        }}
      >
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            onClose();
          }}
        >
          Cancelar
        </Button>
        <Button
          size="small"
          variant="contained"
          onClick={() => Grabar()}
          disabled={
            !boton.CONTROLES.reduce((a, v, index) => {
              if (!v.REQUERIDO) {
                return a;
              } else {
                return a && resp[index];
              }
            }, true)
          }
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DialogoControles;
